import React from 'react';
import {
  titleUI,
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { VaDetails } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import { formatFullName } from '../../../../utils/helpers';

export const childAge = (formData, today = new Date()) => {
  const dob = formData?.childDateOfBirth;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dob || '')) return null;
  const [year, month, day] = dob.split('-').map(Number);
  const birthDate = new Date(year, month - 1, day);
  if (
    birthDate.getFullYear() !== year ||
    birthDate.getMonth() !== month - 1 ||
    birthDate.getDate() !== day ||
    birthDate > today
  )
    return null;
  const birthdayPending =
    today.getMonth() < month - 1 ||
    (today.getMonth() === month - 1 && today.getDate() < day);
  return today.getFullYear() - year - Number(birthdayPending);
};

export const showSchoolQuestion = formData => {
  const age = childAge(formData);
  return age !== null && age >= 18 && age <= 23;
};

export const showDisabilityQuestion = formData => {
  const age = childAge(formData);
  return age !== null && age >= 18;
};

export default {
  uiSchema: {
    ...titleUI(({ formData }) => {
      const name = formatFullName(formData?.childFullName || {});
      return `Additional information about ${name || 'the child'}`;
    }),
    inSchool: yesNoUI({
      title: 'Is the child still in school?',
      required: showSchoolQuestion,
      hideIf: formData => !showSchoolQuestion(formData),
    }),
    seriouslyDisabled: yesNoUI({
      title:
        'Does the child have a permanent disability that prevents them from caring for themself?',
      required: showDisabilityQuestion,
      hideIf: formData => !showDisabilityQuestion(formData),
    }),
    hasBeenMarried: yesNoUI('Has the child ever been married?'),
    'view:permanentDisability': {
      'ui:description': (
        <VaDetails label="What we mean by permanent disability">
          <p>
            For VA benefits purposes, a child has a permanent disability if they
            developed a physical or mental condition before they turned 18 that
            will last their whole life.
          </p>
          <p>
            A child with a permanent disability can’t support or care for
            themselves.
          </p>
        </VaDetails>
      ),
      'ui:options': { displayEmptyObjectOnReview: false },
    },
  },
  schema: {
    type: 'object',
    properties: {
      inSchool: yesNoSchema,
      seriouslyDisabled: yesNoSchema,
      hasBeenMarried: yesNoSchema,
      'view:permanentDisability': { type: 'object', properties: {} },
    },
    required: ['hasBeenMarried'],
  },
};
